import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'header-note',
  templateUrl: './header-note.component.html',
  styleUrls: ['./header-note.component.scss']
})
export class HeaderNoteComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
